// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nform[data-v-3e76e7ec] {\n\tmargin-bottom: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
